// Strings of the Phase 4C-2 ticket additions (chart states and chat paging). The rest of the ticket screens is English only today.
const TEXT = {
  en: {
    chartLoading: "Loading chart…",
    chartError: "The ticket chart could not be loaded",
    chartEmpty: "No ticket messages in this month.",
    chartArchiveUnavailable: "Archived history for this month is unavailable; the chart shows recent messages only.",
    retry: "Retry",
    loadOlder: "Load older messages",
    loadingOlder: "Loading older messages…",
    olderFailed: "Older messages could not be loaded",
  },
  ar: {
    chartLoading: "جارٍ تحميل المخطط…",
    chartError: "تعذّر تحميل مخطط التذاكر",
    chartEmpty: "لا توجد رسائل تذاكر في هذا الشهر.",
    chartArchiveUnavailable: "السجل المؤرشف لهذا الشهر غير متاح؛ يعرض المخطط الرسائل الحديثة فقط.",
    retry: "إعادة المحاولة",
    loadOlder: "تحميل الرسائل الأقدم",
    loadingOlder: "جارٍ تحميل الرسائل الأقدم…",
    olderFailed: "تعذّر تحميل الرسائل الأقدم",
  },
};

export const getTicketText = (lang) => TEXT[lang] || TEXT.en;
